<div class="successful-snackbar-wrapper">
  <div class="content-wrapper">
    <i class="success-icon"></i>
    <div class="text-wrapper">
      <span class="main-text">Success</span>
      @if (data.success_code) {
        <span class="supporting-text"></span>
      }
      @if (data.success_text) {
        <span class="supporting-text"
          >{{data.success_text}}</span
          >
        }
      </div>
    </div>

    <mat-icon (click)="closeSnackBar()">close</mat-icon>
  </div>
